import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useIsMutating } from 'react-query';

import SelectDropDown from '../../common/ReactHookForm/SelectDropDown';
import { USER_MESSAGE } from '../../../actions/User';
import Spinner from '../../common/Spinner';
import MultiSelect from '../../common/Renderers/MultiSelect';
import { usePlateWellActions, useChannels, useControlAnalysisOptions, useAnalysisResults, useTabValue } from '../../../store/plateWellStore';
import useMutateControlAnalysis from '../../Hooks/Analysis/useMutateControlAnalysis';
import { parseApiError } from '../../../utils/basic';
import useFetchControlAnalysisOptions from '../../Hooks/Analysis/useFetchControlAnalysisOptions';
import AnalysisResult from '../../common/TabPanel/AnalysisResult';

const ControlExperimentAnalysis = () => {
    const dispatch = useDispatch();
    const [selectControl, setSelectControl] = useState([]);
    const { register, handleSubmit, control, reset, setError, clearErrors, formState } = useForm();
    const { setControlAnalysisOptions, setTabValue, setAnalysisResults } = usePlateWellActions();
    const chdata = useChannels();
    const tabValue = useTabValue();
    const { plate_uuid } = useParams();
    const controlAnalysisOptions = useControlAnalysisOptions();
    const analysisResults = useAnalysisResults();
    const optionsForChannels = chdata ? chdata?.map(item => item.name) : [];
    const isMutatingControlAnalysis = useIsMutating({ mutationKey: ['controlAnalysis'] });
    const { data, isError, isFetching, isSuccess } = useFetchControlAnalysisOptions(plate_uuid, {

        onSuccess: (data) => {

            const selectData = data?.data?.experiments?.map(item => ({ value: item, label: item }));

            const select = selectData.map(item => item?.value) || [];
            setSelectControl(select);

            setControlAnalysisOptions(selectData);

        },
        onError: (error) => {
            dispatch({    // this will be replaced with react hot tast when redux will be removed
                type: USER_MESSAGE,
                msgType: "error",
                text: parseApiError(error),
                key: crypto.randomUUID()
            });
        }

    });

    const controlAnalysisMutation = useMutateControlAnalysis();
    const onSubmit = async (data) => {

        // Map form field names to API field names
        const apiData = {
            control: data?.Control,
            experiments: data?.Experiments.map(item => item.label),
            metrics: data?.Metrics?.map(item => item.label),
            channel: data?.Channel,
            ignore_wells: data["Ignore Wells"],
            plate_uuid: plate_uuid
        };
        controlAnalysisMutation.mutate({ apiData },
            {
                onSuccess: (response) => {
                    let responseData = JSON.parse(response?.data?.body);

                    setAnalysisResults(responseData);
                    setTabValue("tab4");
                    reset();

                },
                onError: (error) => {
                    dispatch({
                        type: USER_MESSAGE,
                        msgType: "error",
                        text: parseApiError(error),
                        key: crypto.randomUUID()
                    });
                    reset();
                }
            }
        );
    }
    return (
        isMutatingControlAnalysis ? <Spinner text="Analysing... Will direct you to results tab once complete" /> :
            // analysisResults?.length > 0 ?
            //     <GenericTabs tabsData={analysisResults} tabValue={tabValue} /> :
            analysisResults?.length > 0 && tabValue === "tab4" ? <AnalysisResult /> :

                <div className='pt-10 form-container'>
                    <div className='pb-10 form_area'>
                        <p className='px-2 py-2 title text-wrap'>Control/Experiment Analysis:Select Tests & Metrics</p>
                        <p className='px-2 py-2 text-wrap'>Select the control group that you want to compare the other groups against, and the metrics that you want to compare. Control and experimental groups are technical replicates,
                            which are wells with the same sample and assay targets.</p>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='form-group'>
                                <label className='sub-title'>Control</label>
                                {/* <input defaultValue='Duplex' readOnly className='form-style px-4 py-2 rounded-md' {...register("Control")} /> */}
                                <SelectDropDown className='{`selectDropDown w-full form-style  px-4 py-2 rounded-md  `}'
                                    {...register("Control", { required: true })} options={selectControl} name="Control" />
                            </div>

                            <div className='form-group'>
                                <label className='sub-title'>Experiments</label>
                                <Controller
                                    name="Experiments"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { ref, ...field } }) => <MultiSelect {...field} options={controlAnalysisOptions} />}
                                />
                            </div>
                            <div className='form-group'>
                                <label className='sub-title'>Metrics</label>
                                <Controller
                                    name="Metrics"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { ref, ...field } }) => <MultiSelect {...field} />}
                                />
                            </div>
                            <div className='form-group'>
                                <label className='sub-title'>Channel</label>
                                <SelectDropDown className='{`selectDropDown w-full form-style px-4 py-2 rounded-md  `}'
                                    {...register("Channel", { required: true })} options={optionsForChannels} name="Channel" />
                            </div>
                            <div className='form-group'>
                                <label className='sub-title'>Ignore Wells</label>
                                <input placeholder='e.g., D04,E05,B12' className='w-full form-style  px-4 py-2  rounded-md' {...register("Ignore Wells")} />
                            </div>

                            <div className='form-group pt-10'>
                                <button className={`ml-10 bg-custom-green text-white px-2 py-1 h-10 rounded-md font-bold 
                        flex items-center justify-center ${formState.isValid ? 'bg-custom-green' : 'bg-gray-400 cursor-not-allowed'}`} type='submit'>Compare Groups</button>
                            </div>
                        </form>
                    </div>
                </div>

    );
};

export default ControlExperimentAnalysis;